import { createContext } from 'react'

export interface BoardInteraction {
  selected: string | null
  select: (id: string) => void
  enlarge: (id: string) => void
  step: (id: string, key: string) => void
}

export const BoardInteractionContext = createContext<BoardInteraction | null>(null)

/** The visible arrangement, including empty columns, is the keyboard's arrangement. */
export function nextCard(columns: readonly (readonly string[])[], id: string, key: string): string | null {
  const col = columns.findIndex(items => items.includes(id))
  const current = columns[col]
  if (!current) return columns.flat()[0] ?? null
  const row = current.indexOf(id)
  if (key === 'ArrowUp' || key === 'ArrowDown') return current[row + (key === 'ArrowUp' ? -1 : 1)] ?? id
  if (key !== 'ArrowLeft' && key !== 'ArrowRight') return id
  const direction = key === 'ArrowLeft' ? -1 : 1
  for (let at = col + direction; at >= 0 && at < columns.length; at += direction) {
    const items = columns[at]
    if (items?.length) return items[Math.min(row, items.length - 1)] ?? id
  }
  return id
}

export function cardElement(id: string, root: ParentNode = document) {
  return [...root.querySelectorAll<HTMLElement>('[data-board-card]')].find(el => el.dataset.boardCard === id)
}
